@if (enableRedesignedBetCard && rewardTokenImage()?.src) {
    @if (rewardTokenImage(); as image) {
        <img class="reward-token-image" priority ngSrcset="1x, 2x, 3x" [width]="12" [height]="12" [ngSrc]="image.src" [alt]="image.alt" />
    }
} @else {
    <div class="my-bets-used-reward-token__icon">
        <vn-icon name="theme-success-i" size="12" />
    </div>
}

<div class="my-bets-used-reward-token__description">
    <div>{{ tokensTitle }}</div>
</div>

@if (hasDetails) {
    <div class="my-bets-used-reward-token__details">
        <div>{{ detailsText }}</div>
    </div>
}

@if (tokenSignPost(); as token) {
    <div class="my-bets-used-reward-token__award-title">
        <div>{{ token.title }}</div>
    </div>
}
